import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/logo2.png'


const _withScopeId = n => (_pushScopeId("data-v-5966a6a5"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "side-inner" }
const _hoisted_2 = {
  key: 0,
  class: "logo-text"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "接口密钥", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "提现记录", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "代理中心", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "用户管理", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "提现管理", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "软件列表", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "免费授权", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "授权查询", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "退出登录", -1))
const _hoisted_12 = { style: {"font-size":"14px","color":"#595959"} }
const _hoisted_13 = { style: {"text-align":"right","margin-top":"20px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DashboardOutlined = _resolveComponent("DashboardOutlined")!
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_a_sub_menu = _resolveComponent("a-sub-menu")!
  const _component_KeyOutlined = _resolveComponent("KeyOutlined")!
  const _component_BankOutlined = _resolveComponent("BankOutlined")!
  const _component_TeamOutlined = _resolveComponent("TeamOutlined")!
  const _component_UserOutlined = _resolveComponent("UserOutlined")!
  const _component_WalletOutlined = _resolveComponent("WalletOutlined")!
  const _component_ShopOutlined = _resolveComponent("ShopOutlined")!
  const _component_SettingOutlined = _resolveComponent("SettingOutlined")!
  const _component_UnorderedListOutlined = _resolveComponent("UnorderedListOutlined")!
  const _component_AppstoreOutlined = _resolveComponent("AppstoreOutlined")!
  const _component_CodeOutlined = _resolveComponent("CodeOutlined")!
  const _component_GiftOutlined = _resolveComponent("GiftOutlined")!
  const _component_ThunderboltOutlined = _resolveComponent("ThunderboltOutlined")!
  const _component_SearchOutlined = _resolveComponent("SearchOutlined")!
  const _component_a_menu_divider = _resolveComponent("a-menu-divider")!
  const _component_LogoutOutlined = _resolveComponent("LogoutOutlined")!
  const _component_a_menu = _resolveComponent("a-menu")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_modal = _resolveComponent("a-modal")!
  const _component_a_layout_sider = _resolveComponent("a-layout-sider")!

  return (_openBlock(), _createBlock(_component_a_layout_sider, {
    collapsed: _ctx.isCollapsed,
    collapsible: "",
    trigger: null,
    width: 232,
    collapsedWidth: 64,
    class: "side-sider"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", {
          class: "side-logo",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.navigateTo('/')))
        }, [
          _createElementVNode("img", {
            src: _imports_0,
            class: _normalizeClass(["logo-img", { collapsed: _ctx.isCollapsed, hidden: _ctx.logoFailed }]),
            onError: _cache[0] || (_cache[0] = ($event: any) => (_ctx.logoFailed = true)),
            onLoad: _cache[1] || (_cache[1] = ($event: any) => (_ctx.logoFailed = false))
          }, null, 34),
          (!_ctx.isCollapsed && _ctx.logoFailed)
            ? (_openBlock(), _createElementBlock("span", _hoisted_2, "易售SUP授权站"))
            : _createCommentVNode("", true)
        ]),
        _createVNode(_component_a_menu, {
          theme: "dark",
          mode: "inline",
          "inline-collapsed": _ctx.isCollapsed,
          "selected-keys": [_ctx.defaultActive],
          "open-keys": _ctx.openKeys,
          "onUpdate:openKeys": _ctx.onOpenKeysChange,
          class: "side-menu"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_sub_menu, { key: "1" }, {
              icon: _withCtx(() => [
                _createVNode(_component_DashboardOutlined)
              ]),
              title: _withCtx(() => [
                _createTextVNode("数据中心")
              ]),
              default: _withCtx(() => [
                _createVNode(_component_a_menu_item, {
                  key: "/console",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.navigateTo('/console')))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("控制台")
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_menu_item, {
                  key: "/userLog",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.navigateTo('/userLog')))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("用户日志")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_a_menu_item, {
              key: "/dockKey",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.navigateTo('/dockKey')))
            }, {
              icon: _withCtx(() => [
                _createVNode(_component_KeyOutlined)
              ]),
              default: _withCtx(() => [
                _hoisted_3
              ]),
              _: 1
            }),
            _createVNode(_component_a_menu_item, {
              key: "/withdrawal",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.navigateTo('/withdrawal')))
            }, {
              icon: _withCtx(() => [
                _createVNode(_component_BankOutlined)
              ]),
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            }),
            _createVNode(_component_a_menu_item, {
              key: "/agentEmpower",
              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.navigateTo('/agentEmpower')))
            }, {
              icon: _withCtx(() => [
                _createVNode(_component_TeamOutlined)
              ]),
              default: _withCtx(() => [
                _hoisted_5
              ]),
              _: 1
            }),
            (_ctx.user_conf.uid == 1000)
              ? (_openBlock(), _createBlock(_component_a_menu_item, {
                  key: "/userManage",
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.navigateTo('/userManage')))
                }, {
                  icon: _withCtx(() => [
                    _createVNode(_component_UserOutlined)
                  ]),
                  default: _withCtx(() => [
                    _hoisted_6
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.user_conf.uid == 1000)
              ? (_openBlock(), _createBlock(_component_a_menu_item, {
                  key: "/admin/withdrawal",
                  onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.navigateTo('/admin/withdrawal')))
                }, {
                  icon: _withCtx(() => [
                    _createVNode(_component_WalletOutlined)
                  ]),
                  default: _withCtx(() => [
                    _hoisted_7
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_a_sub_menu, { key: "8" }, {
              icon: _withCtx(() => [
                _createVNode(_component_ShopOutlined)
              ]),
              title: _withCtx(() => [
                _createTextVNode("我的小店")
              ]),
              default: _withCtx(() => [
                _createVNode(_component_a_menu_item, {
                  key: "/shopInfo",
                  onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.navigateTo('/shopInfo')))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_SettingOutlined, { style: {"margin-right":"8px"} }),
                    _createTextVNode("小店信息 ")
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_menu_item, {
                  key: "/payChannel",
                  onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.navigateTo('/payChannel')))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_WalletOutlined, { style: {"margin-right":"8px"} }),
                    _createTextVNode("支付通道 ")
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_menu_item, {
                  key: "/orderManage",
                  onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.navigateTo('/orderManage')))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_UnorderedListOutlined, { style: {"margin-right":"8px"} }),
                    _createTextVNode("订单管理 ")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_a_menu_item, {
              key: "/includesList",
              onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.navigateTo('/includesList')))
            }, {
              icon: _withCtx(() => [
                _createVNode(_component_AppstoreOutlined)
              ]),
              default: _withCtx(() => [
                _hoisted_8
              ]),
              _: 1
            }),
            (_ctx.user_conf.uid == 1000)
              ? (_openBlock(), _createBlock(_component_a_sub_menu, { key: "6" }, {
                  icon: _withCtx(() => [
                    _createVNode(_component_CodeOutlined)
                  ]),
                  title: _withCtx(() => [
                    _createTextVNode("开发中心")
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_a_menu_item, {
                      key: "/develop",
                      onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.navigateTo('/develop')))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("数据概览")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_menu_item, {
                      key: "/productManage",
                      onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.navigateTo('/productManage')))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("产品管理")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_menu_item, {
                      key: "/VersionLog",
                      onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.navigateTo('/VersionLog')))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("版本管理")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_menu_item, {
                      key: "/NoticeManage",
                      onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.navigateTo('/NoticeManage')))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("公告管理")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_menu_item, {
                      key: "/DataManage",
                      onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.navigateTo('/DataManage')))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("数据管理")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_a_sub_menu, { key: "7" }, {
              icon: _withCtx(() => [
                _createVNode(_component_GiftOutlined)
              ]),
              title: _withCtx(() => [
                _createTextVNode("卡密管理")
              ]),
              default: _withCtx(() => [
                _createVNode(_component_a_menu_item, {
                  key: "/CarmineList",
                  onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.navigateTo('/CarmineList')))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("卡密列表")
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_menu_item, {
                  key: "/CarmineUse",
                  onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.navigateTo('/CarmineUse')))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("使用卡密")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_a_menu_item, {
              key: "/freeBenefits",
              onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.navigateTo('/freeBenefits')))
            }, {
              icon: _withCtx(() => [
                _createVNode(_component_ThunderboltOutlined)
              ]),
              default: _withCtx(() => [
                _hoisted_9
              ]),
              _: 1
            }),
            _createVNode(_component_a_menu_item, {
              key: "/query",
              onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.navigateTo('/query')))
            }, {
              icon: _withCtx(() => [
                _createVNode(_component_SearchOutlined)
              ]),
              default: _withCtx(() => [
                _hoisted_10
              ]),
              _: 1
            }),
            _createVNode(_component_a_menu_divider),
            _createVNode(_component_a_menu_item, {
              key: "logout",
              onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.openDialog('消息', '您确认要退出登录吗', true, 'outLogin')))
            }, {
              icon: _withCtx(() => [
                _createVNode(_component_LogoutOutlined)
              ]),
              default: _withCtx(() => [
                _hoisted_11
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["inline-collapsed", "selected-keys", "open-keys", "onUpdate:openKeys"]),
        _createVNode(_component_a_modal, {
          open: _ctx.centerDialog.isShow,
          "onUpdate:open": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.centerDialog.isShow) = $event)),
          title: _ctx.centerDialog.title,
          width: "420",
          "mask-closable": false,
          footer: null
        }, {
          default: _withCtx(() => [
            _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.centerDialog.content), 1),
            _createElementVNode("div", _hoisted_13, [
              _createVNode(_component_a_button, {
                style: {"margin-right":"8px"},
                onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.centerDialog.isShow = false))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("取消")
                ]),
                _: 1
              }),
              _createVNode(_component_a_button, {
                type: "primary",
                onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.centerDialogClick(_ctx.centerDialog.clickBind)))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("确认")
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }, 8, ["open", "title"])
      ])
    ]),
    _: 1
  }, 8, ["collapsed"]))
}